import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 查询问卷调查列表
export function queryExamList(data) {
    return http.request({
        url: common.url + '/papi/paper/list',
        method: 'get',
        params: data
    })
}


export function getExamById(id) {
    return http.request({
        url: common.url + '/papi/paper/' + id,
        method: 'get'
    })
}


// 提交考试
export function submitExam(data) {
    return http.request({
        url: common.url + '/papi/exam_history/submitExamHistory',
        method: 'post',
        data: data
    })
}

//考试历史记录
export function queryExamHistoryList(data) {
    return http.request({
        url: common.url + '/papi/exam_history/list',
        method: 'get',
        params: data
    })
}


//获取问卷

